var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-divider",class:{
    [`el-divider--color-${_vm.color}`]: _vm.color,
    'is-vertical': _vm.vertical
  },style:(`height: ${_vm.height}px`)})
}
var staticRenderFns = []

export { render, staticRenderFns }